<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">手表绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>


            <el-col :span="12" class="item">
              <el-form-item label="绑定护士" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="请选择护士" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getNurse"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="Imei号" required prop="imeiAll">
                <el-input v-model="addForm.imeiAll" placeholder="请输入Imei号"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="设备型号" required prop="type">
                <el-select v-model="addForm.type" placeholder="选择设备型号" style="width:100%">
                  <el-option
                      v-for="item in type_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>



          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <Nurse ref="myNurse" v-show="showModalNurse" v-on:closeNurse="showModalNurse=false" v-on:setNurse="setNurse"></Nurse>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Nurse from "@/views/Nurse/Comm/Nurse";


export default {
  name: 'Add',
  props:['setmealList'],
  data() {
    return {
      loading: false,
      showModalNurse: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        userCode:'',
        userName:'',
        imeiAll:'',
        type:'',

        insType:'',
        insCode:'',
        userType:'',
        addFrom:'',

      },

      type_arr:[{
        value:1,
        label:'H09/HX88/HX99'
      },{
        value:2,
        label:'GK217/A30'
      }],

      rules:{
        imeiAll:[
          { required: true, message: '请输入Imei号', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择护士', trigger: 'blur' }
        ],
        type:[
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      }

    }
  },
  components:{
    Nurse
  },
  methods: {
    init(insType,insCode,userType,addFrom){
      this.$refs.addForm.resetFields();
      this.addForm.insType = insType;
      this.addForm.insCode = insCode;
      this.addForm.userType = userType;
      this.addForm.addFrom = addFrom;

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    getNurse(){
      this.showModalNurse = !this.showModalNurse;
      this.$refs.myNurse.init(this.addForm.insType,this.addForm.insCode);
    },
    setNurse(row){
      this.addForm.userCode=row.userCode;
      this.addForm.userName = row.name;
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.addForm.imeiAll.length != 15){
        this.$message.info("imei号长度是15位");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceXiaodou/Add4",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>


</style>
